import React from "react";
import {connect} from "react-redux";
import classNames from "classnames";
import {Feature, Locational} from "../../../../integration/representation/feature";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import {FeltKode} from "../../contract-features-3/domain";
import {
    CloseLaneModal,
    UpdateLanes,
} from "../actions";
import {
    createLaneEdit, getFeltKodeList,
    getLaneFilters,
    getLanesRelativeToMeteringDirection
} from "../../../../laneUtilities";

interface LaneModalProps {
    roadObject: Feature,
    locational: Locational,
    closeModal: CloseLaneModal,
    updateLanes: UpdateLanes
}

interface LaneModalState {
    selectedLanes: FeltKode[];
    selectedFilters: LaneFilter[];
}

class LaneModal extends React.Component<LaneModalProps, LaneModalState> {

    private feltKoder: FeltKode[];

    constructor(props: LaneModalProps) {
        super(props);
        this.feltKoder = getFeltKodeList();
        let selectedLanes: FeltKode[] = [];
        const lanesRelativeToMeteringDirection = getLanesRelativeToMeteringDirection(props.locational);
        if (lanesRelativeToMeteringDirection) {
            try {
                selectedLanes = lanesRelativeToMeteringDirection.map(laneValue => {
                    return this.feltKoder.filter(feltKode => feltKode.value === laneValue)[0];
                }).filter(feltkode => !!feltkode);
            } catch (error) {
                console.error(error);
            }
        }
        this.state = {
            selectedLanes: selectedLanes,
            selectedFilters: [],
        };
    }

    render() {
        let {closeModal, locational} = this.props;

        return (
            <Modal show={true} onHide={() => closeModal()} className={"lane-modal"}>
                <ModalHeader>
                    <ModalTitle>Kjørefelt i forhold til metreringsretning</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <div className="body">
                        <ul className={"lane-modal-filter-list"}>
                            {
                                getLaneFilters().map(filter => {
                                    let felts = this.feltKoder.filter(kode => {
                                        return kode.name.toLowerCase().includes(filter.term)
                                    });
                                    let filterClasses = classNames({
                                        "filter-item": true,
                                        "selected": this.state.selectedFilters.some(selected => selected.term === filter.term),
                                    });
                                    return (
                                        <li key={filter.term} className={filterClasses}
                                            onClick={() => this.toggleFilter(filter)}>{filter.name}
                                            <ul className={"lane-list"}>

                                                {felts.map(felt => {

                                                    let selected = this.state.selectedLanes.some(selected => selected.value === felt.value)

                                                    let llClasses = classNames({
                                                        "lane-item": true,
                                                        "selected": this.state.selectedLanes.some(selected => selected.value === felt.value)
                                                    });
                                                    return (<li className={llClasses} key={felt.value} role="checkbox" aria-selected={selected}
                                                                onClick={(e) => this.toggleSelected(felt, e)}>{felt.name}</li>)
                                                })}

                                            </ul>

                                        </li>
                                    )
                                })
                            }
                        </ul>

                        <div className={"modal-info"}>
                            <p>
                                Valgte kjørefelt
                            </p>
                            <div className={"selected-lanes-list"}>
                                {
                                    this.feltKoder
                                        .filter(kode => this.state.selectedLanes.some(selected => selected.value === kode.value))
                                        .map(lane => {
                                            return (
                                                <div key={lane.value} className={"selected-lane"}>{lane.name}
                                                    <button onClick={(e) => this.toggleSelected(lane, e)}>✕</button>
                                                </div>
                                            )
                                        })}
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={closeModal}>Avbryt</Button>
                    <button className="btn" onClick={() => this.updateLanes()}>OK</button>
                </ModalFooter>

            </Modal>
        );
    }

    toggleSelected(lane: FeltKode, event: React.MouseEvent) {
        event.stopPropagation();
        if (this.state.selectedLanes.some(l => l.value === lane.value)) {
            this.setState({selectedLanes: this.state.selectedLanes.filter(selected => selected.value !== lane.value)});
        } else {
            let selection = this.state.selectedLanes;
            selection.push(lane)
            this.setState({selectedLanes: selection});
        }
    }

    toggleFilter(filter: LaneFilter) {
        if (this.state.selectedFilters.some(f => f.term === filter.term)) {
            this.setState({selectedFilters: this.state.selectedFilters.filter(selected => selected.term !== filter.term)});
        } else {
            let selection = this.state.selectedFilters;
            selection.push(filter)
            this.setState({selectedFilters: selection});
        }
    }

    updateLanes() {
        let {roadObject, locational, updateLanes, closeModal} = this.props;
        const selectedLanesRelativeToMeteringDirection = this.state.selectedLanes.map(lane => lane.value);
        const laneEdit = createLaneEdit(locational, selectedLanesRelativeToMeteringDirection, roadObject.id);
        updateLanes([laneEdit]);
        closeModal();
    }
}

export type LaneFilter = {
    name: string,
    term: string,
}

export default connect()(LaneModal);
